import Cookies from "js-cookie"

export const getTenantFromHostname = () => {
  const hostname = String(window.location.hostname || "").toLowerCase()

  const sessionTenant = sessionStorage.getItem("tenant")
  if (sessionTenant && sessionTenant.trim()) {
    return sessionTenant.trim().toLowerCase()
  }

  const cookieTenant = Cookies.get("tenant")
  if (cookieTenant && cookieTenant.trim()) {
    const t = cookieTenant.trim().toLowerCase()
    sessionStorage.setItem("tenant", t)
    return t
  }

  const parts = hostname.split(".")
  const hasSubdomain = parts.length > 2

  let tenant = null

  if (hasSubdomain) {
    tenant = parts[0]
    if (tenant === "www") tenant = null
  } else {
    tenant = null
  }

  if (tenant && tenant.trim()) {
    tenant = tenant.trim().toLowerCase()
    Cookies.set("tenant", tenant, { expires: 7, sameSite: "Lax" })
    sessionStorage.setItem("tenant", tenant)
    return tenant
  }

  console.warn("[getTenantFromHostname] No tenant found")
  return null
}
